/* Caddy Classics — card swatch selection.
   Chip click selects a color: swaps the card photo to that variant's image,
   points the card links at the variant, and syncs the quick-add form so
   "Add to bag" adds the selected variant. Chips without variant data
   (combined listings) keep their native link behavior. */
if (!customElements.get('cc-card-swatches')) {
  customElements.define(
    'cc-card-swatches',
    class CCCardSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        this.baseUrl = this.dataset.url;
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('.card__swatch');
          if (!chip || !this.contains(chip) || !chip.dataset.variantId) return;
          event.preventDefault();
          this.select(chip, false);
        });
        const current =
          this.querySelector('.card__swatch[data-current]') ||
          this.querySelector('.card__swatch[data-variant-id]');
        if (current) this.select(current, true);
      }

      select(chip, initial) {
        this.querySelectorAll('.card__swatch[aria-current]').forEach((el) =>
          el.removeAttribute('aria-current')
        );
        chip.setAttribute('aria-current', 'true');
        if (!initial) this.swapImage(chip);
        this.syncLinks(chip);
        this.syncForm(chip);
      }

      swapImage(chip) {
        if (!this.card || !chip.dataset.src) return;
        const image = this.card.querySelector('.card__media .media img');
        if (!image) return;
        if (chip.dataset.srcset) image.setAttribute('srcset', chip.dataset.srcset);
        else image.removeAttribute('srcset');
        image.setAttribute('src', chip.dataset.src);
      }

      syncLinks(chip) {
        if (!this.card || !this.baseUrl || !chip.dataset.variantId) return;
        const url = `${this.baseUrl}?variant=${chip.dataset.variantId}`;
        this.card.querySelectorAll(`a[href^="${this.baseUrl}"]`).forEach((link) => {
          if (!link.closest('cc-card-swatches')) link.setAttribute('href', url);
        });
      }

      syncForm(chip) {
        if (!this.card || !chip.dataset.variantId) return;
        const quickAdd = this.card.querySelector('.quick-add');
        if (!quickAdd) return;
        const input = quickAdd.querySelector('input.product-variant-id');
        const button = quickAdd.querySelector('.quick-add__submit');
        if (!input || !button) return; // modal-style quick add — leave it alone
        const available = chip.dataset.available === 'true';
        input.value = chip.dataset.variantId;
        input.disabled = !available;
        button.disabled = !available;
        const label = button.querySelector('span:not(.sold-out-message)');
        if (!label) return;
        if (!this.addLabel) this.addLabel = label.textContent.trim();
        const soldOut = button.querySelector('.sold-out-message');
        label.textContent = available
          ? this.addLabel
          : (soldOut ? soldOut.textContent.trim() : 'Sold out');
      }
    }
  );
}
